import React, { useState } from 'react';
import { Theme, FormControl } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import axios from "axios";
import { globalStore } from '../stores/global';
import { useHistory } from 'react-router-dom';
import 'rsuite/dist/styles/rsuite-default.css';
import _ from 'lodash';
import FormInput from '../components/form-input';
import Button from '../components/custom-button';
import { t } from '../i18n';
import { useAuth } from '../services/auth-check';
import { remoteConfig } from '../firebase';

import LangSelect from '../components/lang-select';
import GlobalStorage from '../utils/custom-storage';
import { API_COMMON_URL, API_V1_USERS } from '../services/ihr-meet-api';

const useStyles = makeStyles((theme: Theme) => ({
    formControl: {
        minWidth: '100%',
        maxWidth: '100%',
    }
}));

type SessionInfo = {
    code: string
}

const defaultState: SessionInfo = {
    code: '',
}

function ActivationCodePage() {
    const roomLinkCode = JSON.parse(localStorage.getItem("roomLinkCode") as string);

    const classes = useStyles();
    const history = useHistory();
    const [required, setRequired] = useState<any>({} as any);
    const [session, setSessionInfo] = useState<SessionInfo>(defaultState);

    const [, setCountryCode] = useState(966);
    const [countries, getCountriesdata] = useState<any[]>([]);

    React.useEffect(() => {
        const fetchData = async () => {
            const response = await axios.get(`${API_COMMON_URL}/countries`);
            getCountriesdata(response.data.data);

            const data = JSON.parse(localStorage.getItem("UserFullData") as string);

            const userData = await axios.get(`${API_V1_USERS}/${data.id}`);
            localStorage.setItem("UserFullData", `${JSON.stringify(userData.data.data)}`);
            if (userData.data.data.is_active) history.push('/');
        }
        fetchData();
    }, [history]);

    const handleSubmit = () => {
        if (!session.code) {
            setRequired({ ...required, missingField: t('home.missingField') });
            return;
        }
        //const roomLinkCode = JSON.parse(localStorage.getItem("roomLinkCode") as string);

        const userInfo = JSON.parse(localStorage.getItem("UserFullData") as string);
        const userData = JSON.parse(localStorage.getItem("UserData") as string);
        const resendCodeData = JSON.parse(localStorage.getItem("resendCodeData") as string);
        globalStore.showLoading();
        let userId = userData ? (userData && userData.user_id) : (userInfo && userInfo.id);

        if ((resendCodeData ? (resendCodeData).toString() : userInfo.activation_code) === session.code) {
            axios.put(`${API_V1_USERS}/accounts/activate/${userId}/${resendCodeData ? resendCodeData : userInfo.activation_code}`)
                .then(response => {
                    localStorage.setItem("UserFullData", `${JSON.stringify(response.data.data)}`);
                    localStorage.setItem("accessToken", `${JSON.stringify(response.data.data.access_token)}`);
                    localStorage.removeItem("resendCodeData");
                    globalStore.showToast({
                        type: 'msg',
                        message: t('toast.codeActivatedSuccessfully'),
                    });
                    if (userInfo) {
                        let data = _.filter(countries, { id: userInfo.country_id });
                        setCountryCode(data[0] && data[0].country_code);
                        localStorage.setItem("countryCode", `${JSON.stringify(data[0] && data[0].country_code)}`);
                    }
                    history.push(roomLinkCode ? `/room/${roomLinkCode}` : `/`);

                })
                .finally(() => {
                    globalStore.stopLoading();
                })
        } else {
            globalStore.showToast({
                type: 'message',
                message: t('toast.invalid_code'),
            });
            globalStore.stopLoading();
        }
    }

    const resendCode = () => {
        const data = JSON.parse(localStorage.getItem("UserFullData") as string);
        const userData = JSON.parse(localStorage.getItem("UserData") as string);
        globalStore.showLoading();
        axios.post(`${API_V1_USERS}/accounts/resend-code/${userData ? userData.user_id : data.id}`)
            .then(response => {
                localStorage.setItem("resendCodeData", `${JSON.stringify(response.data.data)}`)
                globalStore.showToast({
                    type: 'rtmClient',
                    message: t('toast.code_send', { reason: response.data.message }),
                })
            }).catch((err: any) => {
                if (err) {
                    globalStore.showToast({
                        type: 'rtmClient',
                        message: t('toast.something_went_wrong', { reason: err.message }),
                    })
                }
            })
            .finally(() => {
                globalStore.stopLoading();
            })
    }

    const [authorized, redirect] = useAuth('ACTIVATION_CODE');

    if (!authorized) {
        redirect();
        return null;
    }

    return (
        <>
            <div className={`setting-container`}>
                <LangSelect
                    value={GlobalStorage.getLanguage().language.match(/^ar/) ? 0 : 1}
                    onChange={(evt: any) => {
                        const value = evt.target.value;
                        if (value === 0) {
                            localStorage.setItem('language', `${JSON.stringify('ar')}`);
                            document.documentElement.lang = 'ar';
                            globalStore.setLanguage('ar');
                        } else {
                            localStorage.setItem('language', `${JSON.stringify('en')}`);
                            document.documentElement.lang = 'en';
                            globalStore.setLanguage('en');
                        }
                    }}
                    items={[
                        { text: 'عربي', name: 'ar' },
                        { text: 'En', name: 'en' }
                    ]}></LangSelect>
            </div>
            <div className="flex-container">
                <div className="card activation-code">
                    <div className="logo"></div>
                    <h2>{t('activation_code')}</h2>
                    <p className="text-center">{t('pleaseInsertActivationCode')}</p>
                    <p className="text-center">{t('toActivateYourAccount')}</p>
                    <div className="position-content flex-direction-column">
                        <FormControl className={classes.formControl}>
                            <FormInput placeholder={t('enter_code')} value={session.code} onChange={
                                (val: string) => {
                                    setSessionInfo({
                                        ...session,
                                        code: val
                                    });
                                }}
                                requiredText={required.missingField}
                            />
                        </FormControl>
                        <Button name={t('activate')} onClick={handleSubmit} />
                        <Button className="resend-butt" name={t('reSendCode')} onClick={resendCode} />
                    </div>
                </div>
            </div>
        </>
    )
}
export default React.memo(ActivationCodePage);
